import React from 'react';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { Button } from 'components/DesignSystem/Button';

import classes from './IntegrationCard.module.scss';

export interface IntegrationCardProps {
    image: React.ReactNode | string;
    title: string;
    subtitle?: string;
    onConnect: () => void;
}

export const IntegrationCard = ({ image, title, subtitle, onConnect }: IntegrationCardProps) => {
    const hasSubtitle = Boolean(subtitle?.trim());
    const imageElement = typeof image === 'string' ? <img className={classes.image} src={image} alt={'icon'} /> : image;

    return (
        <div className={classes.IntegrationCard}>
            <div className={classes.content}>
                <div className={classes.imageWrapper}>{imageElement}</div>
                <div className={classes.text}>
                    <div className={classes.title}>{title}</div>
                    {hasSubtitle ? <div className={classes.subtitle}>{subtitle}</div> : null}
                </div>
            </div>

            <div className={classes.actions}>
                <Button variant={'secondary'} disabled>
                    Not Connected
                </Button>
                <Button
                    variant={'primary'}
                    onClick={onConnect}
                    startIcon={<MuiIcon icon={'add'} color={'var(--button-primary-fg)'} />}
                >
                    Connect
                </Button>
            </div>
        </div>
    );
};
